export default [
  {
    name: "safeV3",
    text: "Stash V3",
    description:
      "Gain above market stable returns with stablecoins without the volatility of cryptocurrencies.",
    overviewTooltip: `Vaults in Stash invest in yield aggregating strategies that combines both lending pools and bonding curves similar to AMM (Automated Market Makers) liquidity pools to provide highly-efficient trading and low-risk returns. Click to learn more.`,
    tokens: [
      {
        coin: "usdc",
        text: "USDC Coin",
        identity: "USDC-V3",
        icon: require("@/assets/icons/coins/usdc.svg"),
        vaultIcon: require("@/assets/icons/vaults/usdc-vault.svg"),
        approveAccessRequired: true,
        config: {
          fixed: 2,
        },
        isLatest: true,
        aboutTheVault: `The Unagii DeFi Vault is an Ethereum-based protocol that enables users to conveniently earn from automated yield farming by depositing crypto assets into vaults that execute DeFi strategies in a gas-efficient and optimized environment.`,
        howItWorks: `The vault pools users' deposits in a vault architecture and automatically invests the pooled assets into the vault's set strategy. The strategy connects to third-party protocols to auto-harvest yield on incentives rewards earned from providing liquidity, compounding periodically.
        <br/>
        <br/>
        Users simply need to connect their wallet, deposit their asset, and confirm the transaction. Users may withdraw their assets from the vault at any time.
        <br/>
        <br/>
        Note that risks do apply so yield responsibly. Read more in our Docs.`,
        tokenDescription: `USD Coin (USDC) is a digital stablecoin pegged to the United States dollar. USD Coin is managed by a consortium called Centre, which was founded by Circle and includes members from the cryptocurrency exchange Coinbase and Bitcoin mining company Bitmain, an investor in Circle. USDC is issued by a private entity and should not be confused with a central bank digital currency (CBDC)`,
      },
    ],
    isMultiStrategy: true,
    isLegacy: true,
    migrateFrom: "safe",
    active: true,
    apyBasedOn: "15-days",
  },
  {
    name: "growthV3",
    text: "Growth V3",
    description:
      "Earn maximum yields with various stablecoins or other crypto assets on high-risk alpha strategies.",
    overviewTooltip: `Vaults in Growth invest in yield aggregating strategies on higher-risk alpha projects that provide highly-efficient trading and yield-generating vaults with governance incentive tokens. Click to learn more.`,
    tokens: [
      // {
      //   coin: "wbtc",
      //   text: "Wrapped Bitcoin",
      //   identity: "WBTC-V3",
      //   icon: require("@/assets/icons/coins/wbtc.svg"),
      //   vaultIcon: require("@/assets/icons/vaults/wbtc-vault.svg"),
      //   approveAccessRequired: true,
      //   config: {
      //     fixed: 6,
      //   },
      //   isLatest: true,
      //   aboutTheVault: `The Unagii DeFi Vault is an Ethereum-based protocol that enables users to conveniently earn from automated yield farming by depositing crypto assets into vaults that executes DeFi strategies in a gas-efficient and optimized environment.`,
      //   howItWorks: `The vault pools users' deposits in a vault architecture and automatically invests the pooled assets into the vault's set strategy. The strategy connects to third-party protocols to auto-harvest yield on incentives rewards earned from providing liquidity, compounding periodically.
      //   <br />
      //   <br />
      //   Users simply need to connect their wallet, deposit their asset, and confirm the transaction. Users may withdraw their assets from the vault at any time.
      //   <br />
      //   <br />
      //   Note that risks do apply so yield responsibly. Read more in our Docs.`,
      //   tokenDescription:
      //     "Wrapped bitcoin is the ERC-20 token that represents one bitcoin and can be used in decentralized applications (DApps). This gives users the ability to use Bitcoin in the Ethereum ecosystem where they otherwise wouldn't be able to.",
      // },
      {
        coin: "eth",
        text: "Ethereum",
        identity: "ETH-V3",
        icon: require("@/assets/icons/coins/eth.svg"),
        vaultIcon: require("@/assets/icons/vaults/eth-vault.svg"),
        approveAccessRequired: false,
        approveAccessWithdrawal: true,
        config: {
          fixed: 6,
        },
        isLatest: true,
        aboutTheVault: `The Unagii DeFi Vault is an Ethereum-based protocol that enables users to conveniently earn from automated yield farming by depositing crypto assets into vaults that execute DeFi strategies in a gas-efficient and optimized environment.`,
        howItWorks: `The vault pools users' deposits in a vault architecture and automatically invests the pooled assets into the vault's set strategy. The strategy connects to third-party protocols to auto-harvest yield on incentives rewards earned from providing liquidity, compounding periodically.
        <br />
        <br />
        Users simply need to connect their wallet, deposit their asset, and confirm the transaction. Users may withdraw their assets from the vault at any time.
        <br />
        <br />
        Note that risks do apply so yield responsibly. Read more in our Docs.`,
        tokenDescription:
          "Ether is the native cryptocurrency for the Ethereum blockchain and network. It is used to pay transaction fees and as collateral by network validators.",
        withdrawalDisabled: false,
        depositlDisabled: false,
      },
    ],
    isMultiStrategy: true,
    isLegacy: true,
    migrateFrom: "growth",
    active: true,
    apyBasedOn: "3-days",
  },
  {
    name: "safeV2",
    text: "Stash",
    description:
      "Gain above market stable returns with stablecoins without the volatility of cryptocurrencies.",
    overviewTooltip: `Vaults in Stash invest in yield aggregating strategies that combines both lending pools and bonding curves similar to AMM (Automated Market Makers) liquidity pools to provide highly-efficient trading and low-risk returns. Click to learn more.`,
    tokens: [
      {
        coin: "usdc",
        text: "USDC Coin",
        identity: "USDC-V2",
        icon: require("@/assets/icons/coins/usdc.svg"),
        vaultIcon: require("@/assets/icons/vaults/usdc-vault.svg"),
        approveAccessRequired: true,
        config: {
          fixed: 2,
        },
        migrationRequired: true,
        migrateTo: "safeV3",
        isLatest: false,
        aboutTheVault: `The Unagii DeFi Vault is an Ethereum-based protocol that enables users to conveniently earn from automated yield farming by depositing crypto assets into vaults that execute DeFi strategies in a gas-efficient and optimized environment.`,
        howItWorks: `The vault pools users' deposits in a vault architecture and automatically invests the pooled assets into the vault's set strategy. The strategy connects to third-party protocols to auto-harvest yield on incentives rewards earned from providing liquidity, compounding periodically.
        <br/>
        <br/>
        Users simply need to connect their wallet, deposit their asset, and confirm the transaction. Users may withdraw their assets from the vault at any time.
        <br/>
        <br/>
        Note that risks do apply so yield responsibly. Read more in our Docs.`,
        tokenDescription: `USD Coin (USDC) is a digital stablecoin pegged to the United States dollar. USD Coin is managed by a consortium called Centre, which was founded by Circle and includes members from the cryptocurrency exchange Coinbase and Bitcoin mining company Bitmain, an investor in Circle. USDC is issued by a private entity and should not be confused with a central bank digital currency (CBDC)`,
      },
      // {
      //   coin: "dai",
      //   text: "DAI Stablecoin",
      //   identity: "DAI-V2",
      //   icon: require("@/assets/icons/coins/dai.svg"),
      //   vaultIcon: require("@/assets/icons/vaults/dai-vault.svg"),
      //   approveAccessRequired: true,
      //   config: {
      //     fixed: 2,
      //   },
      //   migrationRequired: false,
      //   depositlDisabled: true,
      //   aboutTheVault: `The Unagii DeFi Vault is an Ethereum-based protocol that enables users to conveniently earn from automated yield farming by depositing crypto assets into vaults that execute DeFi strategies in a gas-efficient and optimized environment.`,
      //   howItWorks: `The vault pools users' deposits in a vault architecture and automatically invests the pooled assets into the vault's set strategy. The strategy connects to third-party protocols to auto-harvest yield on incentives rewards earned from providing liquidity, compounding periodically.
      //   <br/>
      //   <br/>
      //   Users simply need to connect their wallet, deposit their asset, and confirm the transaction. Users may withdraw their assets from the vault at any time.
      //   <br/>
      //   <br/>
      //   Note that risks do apply so yield responsibly. Read more in our Docs.`,
      //   tokenDescription: `Dai (or DAI, formerly Sai or SAI) is a stablecoin on the Ethereum blockchain whose value is kept as close to one United States dollar as possible through a system of decentralized participants incentivized by smart contracts to perform maintenance and governance functions.`,
      // },
    ],
    isMultiStrategy: true,
    active: true,
    isLegacy: true,
    apyBasedOn: "15-days",
  },
  {
    name: "growthV2",
    text: "Growth",
    description:
      "Earn maximum yields with various stablecoins or other crypto assets on high-risk alpha strategies.",
    overviewTooltip: `Vaults in Growth invest in yield aggregating strategies on higher-risk alpha projects that provide highly-efficient trading and yield-generating vaults with governance incentive tokens. Click to learn more.`,
    tokens: [
      {
        coin: "wbtc",
        text: "Wrapped Bitcoin",
        identity: "WBTC-V2",
        icon: require("@/assets/icons/coins/wbtc.svg"),
        vaultIcon: require("@/assets/icons/vaults/wbtc-vault.svg"),
        approveAccessRequired: true,
        config: {
          fixed: 6,
        },
        migrationRequired: false,
        withdrawalRequired: true,
        migrateTo: "growthV3",
        isLatest: false,
        aboutTheVault: `The Unagii DeFi Vault is an Ethereum-based protocol that enables users to conveniently earn from automated yield farming by depositing crypto assets into vaults that executes DeFi strategies in a gas-efficient and optimized environment.`,
        howItWorks: `The vault pools users' deposits in a vault architecture and automatically invests the pooled assets into the vault's set strategy. The strategy connects to third-party protocols to auto-harvest yield on incentives rewards earned from providing liquidity, compounding periodically.
        <br />
        <br />
        Users simply need to connect their wallet, deposit their asset, and confirm the transaction. Users may withdraw their assets from the vault at any time.
        <br />
        <br />
        Note that risks do apply so yield responsibly. Read more in our Docs.`,
        tokenDescription:
          "Wrapped bitcoin is the ERC-20 token that represents one bitcoin and can be used in decentralized applications (DApps). This gives users the ability to use Bitcoin in the Ethereum ecosystem where they otherwise wouldn't be able to.",
      },
      {
        coin: "eth",
        text: "Ethereum",
        identity: "ETH-V2",
        icon: require("@/assets/icons/coins/eth.svg"),
        vaultIcon: require("@/assets/icons/vaults/eth-vault.svg"),
        approveAccessRequired: false,
        config: {
          fixed: 6,
        },
        migrationRequired: true,
        migrateTo: "growthV3",
        isLatest: false,
        aboutTheVault: `The Unagii DeFi Vault is an Ethereum-based protocol that enables users to conveniently earn from automated yield farming by depositing crypto assets into vaults that execute DeFi strategies in a gas-efficient and optimized environment.`,
        howItWorks: `The vault pools users' deposits in a vault architecture and automatically invests the pooled assets into the vault's set strategy. The strategy connects to third-party protocols to auto-harvest yield on incentives rewards earned from providing liquidity, compounding periodically.
        <br />
        <br />
        Users simply need to connect their wallet, deposit their asset, and confirm the transaction. Users may withdraw their assets from the vault at any time.
        <br />
        <br />
        Note that risks do apply so yield responsibly. Read more in our Docs.`,
        tokenDescription:
          "Ether is the native cryptocurrency for the Ethereum blockchain and network. It is used to pay transaction fees and as collateral by network validators.",
      },
    ],
    isMultiStrategy: true,
    isLegacy: true,
    active: true,
    apyBasedOn: "3-days",
  },
  {
    name: "safe",
    text: "Stash V1",
    description:
      "Gain above market stable returns with stablecoins without the volatility of cryptocurrencies.",
    overviewTooltip: `Vaults in Stash invest in yield aggregating strategies that combines both lending pools and bonding curves similar to AMM (Automated Market Makers) liquidity pools to provide highly-efficient trading and low-risk returns. Click to learn more.`,
    tokens: [
      {
        coin: "usdc",
        text: "USDC Coin",
        identity: "USDC-V1",
        icon: require("@/assets/icons/coins/usdc.svg"),
        vaultIcon: require("@/assets/icons/vaults/usdc-vault.svg"),
        approveAccessRequired: true,
        config: {
          fixed: 2,
        },
        migrationRequired: false,
        withdrawalRequired: true,
        isLatest: false,
        aboutTheVault: `The Unagii DeFi Vault is an Ethereum-based protocol that enables users to conveniently earn from automated yield farming by depositing crypto assets into vaults that execute DeFi strategies in a gas-efficient and optimized environment.`,
        howItWorks: `The vault pools users' deposits in a vault architecture and automatically invests the pooled assets into the vault's set strategy. The strategy connects to third-party protocols to auto-harvest yield on incentives rewards earned from providing liquidity, compounding periodically.
        <br/>
        <br/>
        Users simply need to connect their wallet, deposit their asset, and confirm the transaction. Users may withdraw their assets from the vault at any time.
        <br/>
        <br/>
        Note that risks do apply so yield responsibly. Read more in our Docs.`,
        tokenDescription: `USD Coin (USDC) is a digital stablecoin pegged to the United States dollar. USD Coin is managed by a consortium called Centre, which was founded by Circle and includes members from the cryptocurrency exchange Coinbase and Bitcoin mining company Bitmain, an investor in Circle. USDC is issued by a private entity and should not be confused with a central bank digital currency (CBDC)`,
      },
      {
        coin: "dai",
        text: "DAI Coin",
        identity: "DAI-V1",
        icon: require("@/assets/icons/coins/dai.svg"),
        vaultIcon: require("@/assets/icons/vaults/dai-vault.svg"),
        approveAccessRequired: true,
        config: {
          fixed: 2,
        },
        migrationRequired: false,
        withdrawalRequired: true,
        isLatest: false,
        aboutTheVault: `The Unagii DeFi Vault is an Ethereum-based protocol that enables users to conveniently earn from automated yield farming by depositing crypto assets into vaults that execute DeFi strategies in a gas-efficient and optimized environment.`,
        howItWorks: `The vault pools users' deposits in a vault architecture and automatically invests the pooled assets into the vault's set strategy. The strategy connects to third-party protocols to auto-harvest yield on incentives rewards earned from providing liquidity, compounding periodically.
        <br/>
        <br/>
        Users simply need to connect their wallet, deposit their asset, and confirm the transaction. Users may withdraw their assets from the vault at any time.
        <br/>
        <br/>
        Note that risks do apply so yield responsibly. Read more in our Docs.`,
        tokenDescription: `Dai (or DAI, formerly Sai or SAI) is a stablecoin on the Ethereum blockchain whose value is kept as close to one United States dollar as possible through a system of decentralized participants incentivized by smart contracts to perform maintenance and governance functions.`,
      },
      {
        coin: "usdt",
        text: "USDT Coin",
        identity: "USDT-V1",
        icon: require("@/assets/icons/coins/usdt.svg"),
        vaultIcon: require("@/assets/icons/vaults/usdt-vault.svg"),
        approveAccessRequired: true,
        config: {
          fixed: 2,
        },
        migrationRequired: false,
        withdrawalRequired: true,
        isLatest: false,
        aboutTheVault: `The Unagii DeFi Vault is an Ethereum-based protocol that enables users to conveniently earn from automated yield farming by depositing crypto assets into vaults that execute DeFi strategies in a gas-efficient and optimized environment.`,
        howItWorks: `The vault pools users' deposits in a vault architecture and automatically invests the pooled assets into the vault's set strategy. The strategy connects to third-party protocols to auto-harvest yield on incentives rewards earned from providing liquidity, compounding periodically.
        <br/>
        <br/>
        Users simply need to connect their wallet, deposit their asset, and confirm the transaction. Users may withdraw their assets from the vault at any time.
        <br/>
        <br/>
        Note that risks do apply so yield responsibly. Read more in our Docs.`,
        tokenDescription: `USDT is a stablecoin on the Ethereum blockchain`,
      },
    ],
    isMultiStrategy: false,
    isLegacy: true,
    active: true,
    apyBasedOn: "15-days",
  },
  {
    name: "growth",
    text: "Growth",
    description:
      "Earn maximum yields with various stablecoins or other crypto assets on high-risk alpha strategies.",
    overviewTooltip: `Vaults in Growth invest in yield aggregating strategies on higher-risk alpha projects that provide highly-efficient trading and yield-generating vaults with governance incentive tokens. Click to learn more.`,
    tokens: [
      {
        coin: "eth",
        text: "Ethereum",
        identity: "ETH-V1",
        icon: require("@/assets/icons/coins/eth.svg"),
        vaultIcon: require("@/assets/icons/vaults/eth-vault.svg"),
        approveAccessRequired: false,
        config: {
          fixed: 6,
        },
        migrationRequired: true,
        migrateTo: "growthV3",
        isLatest: false,
        aboutTheVault: `The Unagii DeFi Vault is an Ethereum-based protocol that enables users to conveniently earn from automated yield farming by depositing crypto assets into vaults that execute DeFi strategies in a gas-efficient and optimized environment.`,
        howItWorks: `The vault pools users' deposits in a vault architecture and automatically invests the pooled assets into the vault's set strategy. The strategy connects to third-party protocols to auto-harvest yield on incentives rewards earned from providing liquidity, compounding periodically.
        <br />
        <br />
        Users simply need to connect their wallet, deposit their asset, and confirm the transaction. Users may withdraw their assets from the vault at any time.
        <br />
        <br />
        Note that risks do apply so yield responsibly. Read more in our Docs.`,
        tokenDescription:
          "Ether is the native cryptocurrency for the Ethereum blockchain and network. It is used to pay transaction fees and as collateral by network validators.",
      },
    ],
    isMultiStrategy: true,
    isLegacy: true,
    active: true,
    apyBasedOn: "3-days",
  },
];
